import React from "react";
import PageLayout from "@/components/layout/PageLayout";
import { Hero, Section, SectionHeader, Bento } from "@/components/layout/Sections";
import { Link } from "react-router-dom";
import { ArrowRight, Users, Bike, Car, Zap } from "lucide-react";

export default function ChiSiamo() {
  return (
    <PageLayout>
      <Hero
        image="/showroom/chi-siamo-hero.jpg"
        title={<>Passione a due<br />e quattro ruote</>}
        subtitle="Noleggio auto, vendita nuovo e usato garantito, officina specializzata. Dealer ufficiale KTM, Husqvarna e GasGas Trial Specialist per Bergamo e provincia."
      />

      {/* La nostra storia */}
      <Section>
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          <div className="aspect-[4/5] bg-cover bg-center bg-white" style={{ backgroundImage: "url(/racing/alberto-business.webp)" }} data-testid="chi-siamo-alberto" />
          <div>
            <span className="label-eyebrow text-[color:var(--nsa-orange)]">La nostra storia</span>
            <h2 className="font-display uppercase tracking-tight text-4xl md:text-5xl mt-3 leading-[0.95]">
              NSA Motors<br />nasce dalla passione
            </h2>
            <div className="mt-6 text-gray-700 leading-relaxed space-y-4">
              <p>
                <strong>NSA Motors</strong> nasce dalla passione di <strong>Alberto Di Rubba</strong> per i motori, con l'obiettivo di creare una concessionaria che unisse
                sotto lo stesso tetto due mondi complementari: <strong>Auto e Moto</strong>. Un progetto nato dall'esperienza sul campo,
                dalla cura per il cliente e dal desiderio di offrire competenza autentica.
              </p>
              <p>
                Nel cuore della bergamasca, a <strong>Casnigo</strong>, il nostro showroom rappresenta oggi un punto di riferimento per gli
                appassionati: <strong>vendita, noleggio, assistenza e officina</strong> multimarca — con reparto ufficiale
                <strong> KTM</strong>, <strong>Husqvarna Motorcycles</strong> e <strong>GasGas Trial</strong>.
              </p>
              <p>
                Dalla passione per le corse è nato anche il <strong>NSA Motors Racing Team</strong>, evoluzione naturale di un progetto che unisce
                metodo, disciplina e identità sportiva. Perché per noi la moto e l'auto non sono solo mezzi: sono cultura, emozione,
                identità.
              </p>
            </div>
          </div>
        </div>
      </Section>

      <Section tone="gray">
        <SectionHeader
          eyebrow="La nostra storia"
          title="Una realtà unica per Auto e Moto"
          description="NSA è il punto di riferimento per chi cerca competenza, cura del cliente ed emozioni motoristiche autentiche. Un unico showroom, due mondi paralleli."
        />
        <Bento
          items={[
            { icon: <Users size={22} />, eyebrow: "Anni di esperienza", title: "Un team che ama ciò che fa", body: "Meccanici, consulenti e appassionati racing lavorano insieme ogni giorno per offrirti la miglior esperienza in concessionaria.", span: "md:col-span-6", tone: "dark" },
            { icon: <Car size={22} />, eyebrow: "Auto", title: "Vendita, noleggio e officina", body: "Un reparto auto completo: consulenza pre-acquisto, servizi post-vendita, officina specializzata multimarca.", span: "md:col-span-3" },
            { icon: <Zap size={22} />, eyebrow: "Moto", title: "Tre marchi, un'unica energia", body: "Enduro, motocross e stradali per ogni tipo di pilota.", span: "md:col-span-3" },
          ]}
        />
      </Section>
      <Section tone="gray">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <div>
            <span className="label-eyebrow text-[color:var(--nsa-orange)]">Vieni a trovarci</span>
            <h2 className="font-display uppercase text-4xl md:text-5xl mt-3">Prenota una visita in showroom</h2>
          </div>
          <Link to="/contatti#form" className="btn-orange label-eyebrow px-6 py-4 inline-flex items-center gap-3">
            SCRIVICI <ArrowRight size={16} />
          </Link>
        </div>
      </Section>
    </PageLayout>
  );
}
